<template>
  <div class="home md-layout md-alignment-top-center">
    <md-progress-bar v-show="loading" class="md-accent md-layout-item md-size-100" md-mode="indeterminate"></md-progress-bar>
    <template v-if="!loading">
      <md-card class="md-layout-item md-size-65">
        <md-card-header>
          <h1 class="md-title">Bank Balance: {{currentBankBalance | currency}}</h1>
        </md-card-header>
      </md-card>
      <div class="md-layout-item md-size-80 spacer"></div>
      <md-table md-card class="md-layout-item md-size-65">
        <md-table-toolbar>
          <h1 class="md-title">Latest Transactions</h1>
        </md-table-toolbar>
        <md-table-row>
          <md-table-head>Account</md-table-head>
          <md-table-head>Change</md-table-head>
          <md-table-head>Date</md-table-head>
        </md-table-row>
        <md-table-row v-for="transaction of summaryTransactions" v-bind:key="transaction['.key']">
          <md-table-cell>{{transaction.accountName}}</md-table-cell>
          <md-table-cell :class="{'red': transaction.amount < 0, 'green': transaction.amount > 0}">{{transaction.amount | currency}}</md-table-cell>
          <md-table-cell>{{transaction.timestamp | date}}</md-table-cell>
        </md-table-row>
      </md-table>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import {db } from '@/db'
export default {
  name: 'home',
  computed: {
    ...mapGetters(['summaryTransactions', 'currentBankBalance']),
    loading: function(){
      return this.summaryTransactions.length === 0;
    },
  },
      beforeCreate(){
         this.$store.dispatch('bindSummaryTransactions', {ref: db.ref('bankTransactions').orderByChild('timestamp').limitToLast(5)});
         this.$store.dispatch('bindStudents', { ref: db.ref('/lists/currentStudents').orderByChild('name') });
         this.$store.dispatch('bindStaff', { ref: db.ref('lists/currentStaff').orderByChild('name') });
         this.$store.dispatch('bindAccounts', { ref: db.ref('bankAccounts').orderByChild('archived').endAt(false) });
      }
  
}
</script>

<style lang="scss">
@import "~vue-material/dist/theme/engine";

.red{
  color: md-get-palette-color(red, A700) !important
}
.green{
  color: md-get-palette-color(green, 700)
}
.spacer{
  height: 2em;
}
</style>

